/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wsc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Will it change my line breaks?`)
};

const es_wsc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cambiará mis saltos de línea?`)
};

const de_wsc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändert es meine Zeilenumbrüche?`)
};

const nl_wsc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verandert het mijn regeleinden?`)
};

const fr_wsc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changera-t-il mes sauts de ligne ?`)
};

const it_wsc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambierà i miei segni di interruzione di riga?`)
};

const pt_br2_wsc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mudará minhas quebras de linha?`)
};

const pt_wsc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai alterar as minhas quebras de linha?`)
};

const ja_wsc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行の改行は変わりますか？`)
};

const zh_wsc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它会改变我的换行符吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wsc_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wsc_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wsc_faq2_q", locale)
	if (locale === "en") return en_wsc_faq2_q(inputs)
	if (locale === "es") return es_wsc_faq2_q(inputs)
	if (locale === "de") return de_wsc_faq2_q(inputs)
	if (locale === "nl") return nl_wsc_faq2_q(inputs)
	if (locale === "fr") return fr_wsc_faq2_q(inputs)
	if (locale === "it") return it_wsc_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_wsc_faq2_q(inputs)
	if (locale === "pt") return pt_wsc_faq2_q(inputs)
	if (locale === "ja") return ja_wsc_faq2_q(inputs)
	return zh_wsc_faq2_q(inputs)
};